import React from 'react'

function Check() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="110.88" height="110.88" viewBox="0 0 110.88 110.88"><defs><style>{`.a{fill:#f37320;}.b{fill:#e2e2e2;}`}</style></defs><path class="a" d="M124.085,113.675h0a3.992,3.992,0,0,1-3.065-1.393L99.987,89.438a4.142,4.142,0,1,1,6.129-5.572l18.109,19.641L174.371,53.5a4.039,4.039,0,0,1,5.85,0,4.161,4.161,0,0,1,0,5.851L127.01,112.422A3.794,3.794,0,0,1,124.085,113.675Z" transform="translate(-72.545 -38.316)" /><path class="b" d="M55.44,110.88A55.44,55.44,0,1,1,55.44,0a4.1,4.1,0,0,1,4.179,4.179A4.1,4.1,0,0,1,55.44,8.358,47.082,47.082,0,1,0,102.523,55.44a4.179,4.179,0,1,1,8.358,0A55.585,55.585,0,0,1,55.44,110.88Z" /></svg>
  )
}

export default Check